import React from 'react';
import { PaymentForm } from 'Forms/PaymentForm';
import { SubmitButton } from 'Components/Fields/Buttons';
import { Modal } from 'Components/Modal';

const RestartUpdatePayment = ({ onClose, onPaymentSubmit }) => {
  return (
    <Modal isShowing onClose={onClose} customClass="restartChurnedPaymentModal">
      <div className="restartChurnedPaymentForm">
        <div className="paymentText">
          <div className="title">Update Your Payment Information</div>
          <div className="description">Please update your card information to restart your plan.</div>
          <div className="divider" />
        </div>
        <PaymentForm
          editForm
          showSecureCheckoutLabel={false}
          onFormSubmit={onPaymentSubmit}
          onCancelClick={onClose}
          submitButtonText="Restart Plan"
          showCancelButton
        />
      </div>
    </Modal>
  );
};

const RestartPlanSuccess = ({ onClose, onSuccessClick }) => (
  <Modal isShowing onClose={onClose} customClass="restartConfirmationModal">
    <div className="modalBody">
      <div className="title">Welcome back to Fox Nation!</div>
      <div className="description">You will receive an email confirming your subscription. Enjoy your shows!</div>
      <div className="submitButton">
        <SubmitButton text="Start Watching" onClick={onSuccessClick} />
      </div>
    </div>
  </Modal>
);

export const RestartConfirmationModal = ({
  onClose,
  onPaymentSubmit,
  onSuccessClick,
  paymentMethodRequired,
  showSuccessModal,
}) => {
  if (showSuccessModal) {
    return <RestartPlanSuccess onClose={onClose} onSuccessClick={onSuccessClick} />;
  }
  if (paymentMethodRequired) {
    return <RestartUpdatePayment onClose={onClose} onPaymentSubmit={onPaymentSubmit} />;
  }
  return null;
};
